import { render, staticRenderFns } from "./storeRightBox.vue?vue&type=template&id=b19a18b4&scoped=true&"
import script from "./storeRightBox.vue?vue&type=script&lang=js&"
export * from "./storeRightBox.vue?vue&type=script&lang=js&"
import style0 from "./storeRightBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./storeRightBox.vue?vue&type=style&index=1&id=b19a18b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19a18b4",
  null
  
)

export default component.exports